import React, { useMemo, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import classes from './Header.module.css'
import gridClasses from '../../styles/grid.module.css'
import lmsLogo from '../../assets/images/new-logo.png'
import { ReactComponent as MenuIcon } from '../../assets/icons/menu.svg'
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg'
import { ReactComponent as CartIcon } from '../../assets/icons/cart.svg'
import { ReactComponent as HeartIcon } from '../../assets/icons/heart.svg'
import { ReactComponent as RatingIcon } from '../../assets/icons/rating.svg'
import { ReactComponent as CoursebookIcon } from '../../assets/icons/coursebook.svg'
import { ReactComponent as PresentationIcon } from '../../assets/icons/presentation.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg'
import { ReactComponent as HomeIcon } from '../../assets/icons/home.svg'
import { HeaderSearch } from './Header'
import {
    HeaderDropdown,
    HeaderDropdownItem,
    DropdownDivider,
    HeaderDropdownButton,
} from './HeaderDropdown'
import { useDispatch, useSelector } from 'react-redux'
import { userActions, userSelectors } from '../../redux/userSlice'
import { UserTypes } from '../../util/constants'
import { getImageURL } from '../../util/functions'
import avatar from '../../assets/images/avatar-dark.svg'
import useCompanyLogo from '../../hooks/useCompanyLogo'
import { cartSelectors } from '../../pages/Cart/cartSlice'

// TODO: Hook this directly to the store/context
const UserDetails = ({ className, ...props }) => {
    const userDetails = useSelector(userSelectors.userDetails)
    const fullName = `${userDetails.firstname} ${userDetails.lastname}`
    return (
        <div className={classNames(classes.userDetails, className)} {...props}>
            <h5 className={classes.userName}>{fullName}</h5>
            <h6 className={classes.userEmail}>{userDetails.email}</h6>
        </div>
    )
}

const ItemCount = ({ icon, count, color, className, ...props }) => (
    <div className={classNames(classes.itemCount, className)} {...props}>
        <span className={classes.itemCountIcon} style={{ '--color': color }}>
            {icon}
        </span>
        <span className={classes.itemCountText}>{count}</span>
    </div>
)

export const AuthenticatedHeader = ({ className, ...props }) => {
    const [open, setOpen] = useState(false)
    const cartItems = useSelector(cartSelectors.cartItems)

    console.log('gad', cartItems)

    const location = useLocation()

    const initialSearch = useMemo(() => {
        return new URLSearchParams(location.search).get('search') || ''
    }, [location.search])

    const onSearch = () => {
        //Ah yes. search * 3
        history.push(`/app/browse/search?search=${search}`)
    }
    const [search, setSearch] = useState(initialSearch)
    const [searchVisible, setSearchVisible] = useState(false)

    const userType = useSelector(userSelectors.userType)
    const userDetails = useSelector(userSelectors.userDetails)

    const {
        logo: companyLogo,
        companyname,
        domainName: businessDomainName,
    } = userDetails

    const isLoggedIn = useSelector(userSelectors.isLoggedIn)
    const isBusinessOwner = userType === UserTypes.Business
    const isBeneficiary = userType === UserTypes.Beneficiary

    const shouldShowCustomLogo = isBusinessOwner || isBeneficiary
    const domainName =
        isBeneficiary || isBusinessOwner ? businessDomainName : ''

    const history = useHistory()
    const dispatch = useDispatch()

    const logOut = () => {
        dispatch(userActions.logout())
        history.push(`/app/auth/sign-in`)
    }

    const { logo } = useCompanyLogo(domainName)

    const hasCustomLogo = !!companyLogo || !!logo

    let homeRoute = '/'

    if (isBeneficiary) homeRoute = '/app/beneficiary/my-courses'

    return (
        <div
            className={classNames(
                classes.header,
                classes.headerWhite,
                classes.headerAuthenticated,
                isBeneficiary && classes.beneficiaryHeader,
                className
            )}
            {...props}
        >
            <div className={classNames(gridClasses.container)}>
                <div className={classes.headerContainer}>
                    <div className={classes.mobileActions}>
                        <button
                            className={classes.navToggle}
                            onClick={() => setOpen(true)}
                        >
                            <MenuIcon />
                        </button>
                        <button
                            className={classes.searchButton}
                            onClick={() => setSearchVisible(true)}
                        >
                            <SearchIcon />
                        </button>
                    </div>
                    <Link
                        to={homeRoute}
                        className={classNames(classes.headerBrand)}
                    >
                        {!shouldShowCustomLogo && (
                            <img
                                alt="SME Upturn Logo"
                                src={lmsLogo}
                                className={classes.headerBrandImage}
                            />
                        )}
                        {shouldShowCustomLogo && hasCustomLogo && (
                            <img
                                alt="Logo"
                                src={getImageURL(logo || lmsLogo)}
                                className={classes.headerBrandImage}
                            />
                        )}
                        {shouldShowCustomLogo && (
                            <span className={classes.headerBrandName}>
                                {companyname}
                            </span>
                        )}
                    </Link>
                    <div
                        className={classNames(
                            classes.mobileSearchItem,
                            searchVisible && classes.mobileSearchItemActive
                        )}
                    >
                        <button
                            className={classes.closeButton}
                            onClick={() => setSearchVisible(false)}
                        >
                            <CloseIcon className={classes.closeIcon} />
                        </button>
                        <HeaderSearch
                            value={search}
                            onChange={setSearch}
                            onTriggerSearch={onSearch}
                        />
                    </div>
                    <nav
                        className={classNames(
                            classes.headerLinks,
                            classes.headerAuthLinks,
                            open && classes.linksOpen
                        )}
                    >
                        <ul
                            className={classNames(
                                classes.headerLinkList,
                                classes.headerAuthLinkList
                            )}
                        >
                            <li
                                style={{
                                    marginRight: 20,
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Link
                                    to="/app/dashboard"
                                    className={classes.cartLink}
                                >
                                    <HomeIcon
                                        style={{ width: 20, height: 20 }}
                                    />
                                </Link>
                            </li>
                            {!isBeneficiary && (
                                <HeaderDropdown title="Browse">
                                    <HeaderDropdownItem
                                        title="All Courses"
                                        url="/app/browse/courses"
                                        icon
                                    />
                                    <HeaderDropdownItem
                                        title="All Classes"
                                        url="/app/browse/classes"
                                        icon
                                    />
                                </HeaderDropdown>
                            )}
                            {!isBeneficiary && (
                                <li className={classes.headerSearchItem}>
                                    <HeaderSearch
                                        value={search}
                                        onChange={setSearch}
                                        onTriggerSearch={onSearch}
                                    />
                                </li>
                            )}
                            {isBusinessOwner && (
                                <HeaderDropdown
                                    className={classes.headerManageItem}
                                    title="Manage"
                                >
                                    <HeaderDropdownItem
                                        title="Manage users"
                                        url="/app/business/users"
                                    />
                                    <HeaderDropdownItem
                                        title="Settings"
                                        url="/app/business/settings"
                                    />
                                    <HeaderDropdownItem
                                        title="Dashboard"
                                        url="/app/dashboard"
                                    />
                                </HeaderDropdown>
                            )}
                            {!isBeneficiary && userType && (
                                <HeaderDropdown title="My enrollments">
                                    <HeaderDropdownItem
                                        title="My Courses"
                                        url="/app/my-courses"
                                        icon
                                    />
                                    <HeaderDropdownItem
                                        title="My Classes"
                                        url="/app/my-classes"
                                        icon
                                    />
                                </HeaderDropdown>
                            )}
                        </ul>
                    </nav>
                    {!isBeneficiary && (
                        <div
                            className={classNames(
                                classes.mobileActions,
                                classes.authActions
                            )}
                        >
                            <Link
                                to="/app/wishlist"
                                className={classes.wishlistLink}
                            >
                                <HeartIcon />
                            </Link>
                            <Link to="/app/cart" className={classes.cartLink}>
                                <CartIcon />
                                <span className={classes.cartNotification}>
                                    {cartItems?.length}
                                </span>
                            </Link>
                        </div>
                    )}

                    <HeaderDropdown
                        title="Account"
                        image={
                            userDetails.profilepicture
                                ? getImageURL(userDetails.profilepicture)
                                : avatar
                        }
                        imageOnly
                        icon
                        listItem={false}
                        className={classes.accountDropdown}
                        triggerOnClick
                    >
                        {isLoggedIn && (
                            <React.Fragment>
                                <UserDetails />
                                {!isBeneficiary && (
                                    <div className={classes.itemCountList}>
                                        <ItemCount
                                            icon={<RatingIcon />}
                                            color="#93F2FF"
                                            count={userDetails.loyalitypoint}
                                        />
                                        <ItemCount
                                            icon={<CoursebookIcon />}
                                            color="#B4A3FF"
                                            count={userDetails.freeCourses}
                                        />
                                        <ItemCount
                                            icon={<PresentationIcon />}
                                            color="#FFA969"
                                            count={userDetails.freeClasses}
                                        />
                                    </div>
                                )}
                                <DropdownDivider
                                    spacing={{ top: 11, bottom: 17 }}
                                />
                                <HeaderDropdownItem
                                    title="My account"
                                    url={
                                        !isBeneficiary
                                            ? '/app/account/profile'
                                            : '/app/beneficiary/settings/profile'
                                    }
                                />
                                {!isBeneficiary ? (
                                    <React.Fragment>
                                        <HeaderDropdownItem
                                            title="Purchase History"
                                            url="/app/account/purchase-history"
                                        />
                                        <DropdownDivider
                                            spacing={{ top: 7, bottom: 12 }}
                                        />
                                    </React.Fragment>
                                ) : (
                                    <div style={{ marginTop: 15 }} />
                                )}
                                <HeaderDropdownButton
                                    title="Log out"
                                    onClick={logOut}
                                />
                            </React.Fragment>
                        )}
                        {!isLoggedIn && (
                            <React.Fragment>
                                <HeaderDropdownItem
                                    title="Login"
                                    url="/app/auth/sign-in"
                                />
                                <HeaderDropdownItem
                                    title="Sign Up"
                                    url="/app/auth/sign-up"
                                />
                                <HeaderDropdownItem
                                    title="Upturn LMS for Business"
                                    url="/business"
                                />
                            </React.Fragment>
                        )}
                    </HeaderDropdown>
                </div>
                {/* <div
                    className={classes.backToHomepage}
                    onClick={() => history.push('/')}
                >
                    {'< Back to homepage'}
                </div> */}
                <div
                    className={classNames(
                        classes.drawerBackground,
                        open && classes.backgroundActive
                    )}
                    onClick={() => setOpen(false)}
                />
            </div>
        </div>
    )
}
